export default "__VITE_ASSET__D$Cujesx__"